module.exports = __webpack_public_path__ + "img/arturo-de-la-fuente.070641d9.jpg";